import { debugLogWithTime } from "../log";
import { Emitter } from "./disposable/event";
const getState = () => {
  if (document.visibilityState === "hidden") {
    return "hidden";
  }
  if (document.hasFocus()) {
    return "active";
  }
  return "passive";
};
let state = getState();
const emitter = new Emitter();
function registerPageLifeCycleListener(listener) {
  return emitter.event(listener);
}
const onStateChange = (nextState) => {
  const prevState = state;
  if (nextState !== prevState) {
    debugLogWithTime(`[page-lifecycle] page lifecycle state change: ${prevState} >>> ${nextState}`);
    state = nextState;
    emitter.fire([prevState, nextState]);
  }
};
const opts = { capture: true };
["pageshow", "focus", "blur", "visibilitychange", "resume"].forEach((type) => {
  window.addEventListener(type, () => onStateChange(getState()), opts);
});
window.addEventListener(
  "freeze",
  () => {
    onStateChange("frozen");
  },
  opts
);
window.addEventListener(
  "pagehide",
  (event) => {
    onStateChange(event.persisted ? "frozen" : "terminated");
  },
  opts
);
export {
  registerPageLifeCycleListener
};
